import { io } from "socket.io-client"

const socket = io(window.localStorage.dev === "true" ? "http://localhost:81" : window.origin)

export default socket